module.exports = __webpack_public_path__ + "img/hanataba.71ac5e2f.jpeg";